import { createSelector } from 'reselect'

import { getJobExperiences } from '../modules/jobExperiences'
import { getCandidateProfile } from '../modules/candidate'

export const jobExperiencesList = createSelector([getJobExperiences], ({ data: jobExperiencesList }) => {
  const sortedJobExperiences = [...jobExperiencesList].sort((a, b) => {
    const jobRoleA = a.job_role
    const jobRoleB = b.job_role

    if (!jobRoleA && !jobRoleB) return 0
    if (!jobRoleA) return 1
    if (!jobRoleB) return -1

    return jobRoleA.name.localeCompare(jobRoleB.name)
  })

  return sortedJobExperiences.map(jobExperience => ({
    editing: jobExperience.editing,
    isNew: jobExperience.isNew,
    tempId: jobExperience.tempId,
    id: jobExperience.id,
    years_experience: jobExperience.years_experience,
    name: jobExperience.job_role && jobExperience.job_role.name,
    job_role_id: jobExperience.job_role && jobExperience.job_role.id,
    formName: `jobExperience[je-${jobExperience.id || jobExperience.tempId}]`,
  }))
})

export const currentlyEditingFormNames = createSelector([getJobExperiences], ({ data: jobExperiences }) => {
  return jobExperiences.filter(job => !!job.editing).map(job => `jobExperience[je-${job.id || job.tempId}]`)
})

export const hasJobExperiences = createSelector([getJobExperiences], ({ data: jobExperiencesList }) => {
  return !!jobExperiencesList.length
})

export const hasSubmittedJobExperiences = createSelector([getJobExperiences], ({ data: jobExperiencesList }) => {
  return !!jobExperiencesList.some(jobExperience => !jobExperience.isNew)
})

export const loading = createSelector([getJobExperiences], ({ fetching }) => !!fetching)

const isInTech = workInTech => {
  if (workInTech === null) return ''
  if (!workInTech) return 'not_in_tech'
  return 'different_tech_role'
}

export const initialAreaFormValues = createSelector(
  [getCandidateProfile],
  ({ other_role, primary_role, primary_role_experience, work_in_tech }) => {
    return {
      other_role,
      primary_role,
      primary_role_experience,
      work_in_tech: isInTech(work_in_tech),
    }
  },
)

const staticDataSelector = state => state.static_data

export const primaryRoles = createSelector([staticDataSelector], ({ primary_roles_map: primaryRolesMap = [] }) => {
  return primaryRolesMap.map(({ name: value, display_name: label }) => ({ label, value }))
})

export const availableRoles = createSelector([staticDataSelector, getJobExperiences], ({ roles }, { data: jobExperiencesList }) => {
  if (!roles) return []

  const selectedJobExperienceIds = jobExperiencesList.map(jobExperience => {
    if (!jobExperience.job_role) return

    return jobExperience.job_role.id
  })

  return roles.filter(role => !selectedJobExperienceIds.includes(role.id))
})
